import { BrandMark } from "./Icons";
import type { SiteConfig } from "../site-config";

export function BrandHeader({ siteConfig }: { siteConfig: SiteConfig }) {
  return (
    <header className="brand-header">
      <a className="brand" href="/" aria-label="お問い合わせ トップ">
        {siteConfig.chatAvatarUrl ? (
          <img className="brand-logo" src={siteConfig.chatAvatarUrl} alt="" aria-hidden="true" />
        ) : <BrandMark />}
        <span>{siteConfig.companyName}</span>
      </a>
    </header>
  );
}
